import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import { getLocalizedText as text } from '@vp-dst/localization-util';

import ScreenSizeUtil from 'utils/ScreenSizeUtil';
import BundleUtil from 'utils/BundleUtil';

import withScreenClass from 'components/highOrder/withScreenClass';
import SectionHeading from 'components/SectionHeading';
import Typography from 'components/vistaprintUILibrary/Typography';

import instagramIcon from 'images/icons/instagram.svg';

function GetInspired(props) {
  const {
    screenClass,
  } = props;

  const isSmallScreen = ScreenSizeUtil.isSmallScreen(screenClass);

  return (
    <div
      style={{
        marginBottom: 50,
      }}
    >
      <Row>
        <Col>
          <div
            style={{
              display: 'flex',
              flexDirection: isSmallScreen ? 'column' : 'row',
              justifyContent: 'center',
            }}
          >
            <SectionHeading
              text={text('get-inspired')}
              alignment="center"
              containerStyle={{
                width: 'auto',
              }}
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginLeft: 10,

                alignSelf: isSmallScreen ? 'center' : 'flex-start',
              }}
            >
              <img
                src={BundleUtil.getFullyQualifiedURL(instagramIcon)}
                alt="Instagram"
                style={{
                  height: isSmallScreen ? 24 : 36,
                  width: isSmallScreen ? 24 : 36,
                }}
              />
              <Typography
                variant="heading3"
                style={{
                  marginLeft: 10,
                }}
                text={text('hashtag-vistaprint')}
              />
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* Instagram widget is injected here via a script in the template html */}
          <div id="olapic_specific_widget" />
        </Col>
      </Row>
    </div>
  );
}

GetInspired.propTypes = {
  screenClass: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired,
};

export default withScreenClass(GetInspired);



// WEBPACK FOOTER //
// ./src/components/GetInspired.js